import { ScrollReveal } from "@/components/base/ScrollAnimations";
import { techPartnersWhatIs } from "@/mocks/techPartnersData";

export default function TechPartnersWhatIs() {
  return (
    <section className="bg-white py-16 md:py-24 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-4xl mx-auto text-center">
          <ScrollReveal>
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-tie-teal/10 mb-4 md:mb-6">
              <span className="text-xs font-semibold text-tie-teal uppercase tracking-wider">
                / The PIIC Initiative
              </span>
            </div>
            <h2 className="font-serif text-2xl md:text-3xl lg:text-4xl font-bold text-tie-text-primary leading-tight">
              {techPartnersWhatIs.title}
            </h2>
          </ScrollReveal>

          <div className="mt-6 md:mt-8 space-y-4">
            {techPartnersWhatIs.paragraphs.map((p, i) => (
              <ScrollReveal key={i} delay={i * 100}>
                <p className="text-sm md:text-base text-tie-text-secondary leading-relaxed">
                  {p}
                </p>
              </ScrollReveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}